let path = `/users/`;
import accountRequest from './request/accountRequest';
function update(user) {
  return accountRequest.put(path, user);
}

function get() {
  accountRequest.setStoreId('');
  return accountRequest.get(path + `info`);
}

function getStores(lastId) {
  accountRequest.setStoreId('');
  const query = lastId ? `?lastId=${lastId}` : '';
  return accountRequest.get(path + `stores` + query);
}

function addStore(store) {
  return accountRequest.post(path + `create-store`, store);
}

export const userService = {
  update,
  get,
  getStores,
  addStore,
};
